// REPORTS-UX-1 — saved report views API + hook.
// Server is the system of record (per-user, audited). All endpoints self-scope
// to the current user; params carry the display-only {report, view} snapshot.
import { useState, useEffect, useCallback } from "react";
import { apiFetch } from "../api";

export function listSavedViews(reportId) {
  const q = reportId ? `?report_id=${encodeURIComponent(reportId)}` : "";
  return apiFetch(`/reports/saved-views${q}`).then((d) => d.views || []);
}
export function createSavedView(reportId, label, params) {
  return apiFetch("/reports/saved-views", { method: "POST", body: { report_id: reportId, label, params } });
}
export function updateSavedView(id, label, params) {
  return apiFetch(`/reports/saved-views/${id}`, { method: "PATCH", body: { report_id: "", label, params } });
}
export function deleteSavedView(id) {
  return apiFetch(`/reports/saved-views/${id}`, { method: "DELETE" });
}

// Hook: the saved views for one report, with optimistic create/delete.
export function useSavedViews(reportId) {
  const [views, setViews] = useState([]);
  const [loading, setLoading] = useState(false);
  const reload = useCallback(() => {
    if (!reportId) { setViews([]); return; }
    setLoading(true);
    listSavedViews(reportId).then((v) => setViews(v)).catch(() => setViews([])).finally(() => setLoading(false));
  }, [reportId]);
  useEffect(() => { reload(); }, [reload]);

  const save = useCallback((label, params) => {
    return createSavedView(reportId, label, params).then((row) => {
      setViews((vs) => [...vs.filter((v) => v.label !== label), row].sort((a, b) => a.label.localeCompare(b.label)));
      return row;
    });
  }, [reportId]);
  const remove = useCallback((id) => {
    setViews((vs) => vs.filter((v) => v.id !== id));
    return deleteSavedView(id).catch(() => reload());
  }, [reload]);

  return { views, loading, reload, save, remove };
}
